import React, { useCallback, useState } from 'react';
import { Box, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Translator from '%app/js/common/services/translator';
import WhatField from '../SearchPanel/WhatField';
import useWhatSearchNavigation from '../SearchPanel/useWhatSearchNavigation';
import { LABEL_KEYS, PLACEHOLDER_KEYS, SUBMIT_KEY } from '../SearchPanel/searchPanelKeys';
import SEARCH_SUBMIT_BUTTON_SX from '../SearchPanel/submitButtonStyles';

const FORM_SX = {
    display: 'flex',
    gap: 1,
    width: '100%',
    alignItems: { xs: 'stretch', sm: 'flex-end' },
    flexDirection: { xs: 'column', sm: 'row' },
};

const FIELD_SX = {
    flex: 1,
    minWidth: 0,
};

const SUBMIT_SX = {
    ...SEARCH_SUBMIT_BUTTON_SX,
    width: { xs: '100%', sm: 'auto' },
};

function NotFoundSearch() {
    const [term, setTerm] = useState('');
    const { goToSuggestedEvent, goToSearchResults } = useWhatSearchNavigation();

    const submitSearch = useCallback(() => {
        goToSearchResults({ what: term.trim() });
    }, [goToSearchResults, term]);

    const handleSubmit = useCallback((event) => {
        event.preventDefault();
        submitSearch();
    }, [submitSearch]);

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            data-testid="not-found-search"
            sx={FORM_SX}
        >
            <Box sx={FIELD_SX}>
                <WhatField
                    label={Translator.trans(LABEL_KEYS.what)}
                    placeholder={Translator.trans(PLACEHOLDER_KEYS.what)}
                    value={term}
                    onChange={setTerm}
                    onSelectSuggestion={goToSuggestedEvent}
                    onShowAllResults={submitSearch}
                    hideLabel
                />
            </Box>
            <Button
                type="submit"
                variant="contained"
                startIcon={<SearchIcon fontSize="small" />}
                sx={SUBMIT_SX}
                data-testid="not-found-search-submit"
            >
                {Translator.trans(SUBMIT_KEY)}
            </Button>
        </Box>
    );
}

export default NotFoundSearch;
